import style from "@styles/pages/flow/boxes/Box.module.scss";
import classnames from "classnames/bind";
import React from "react";
import { Handle } from "reactflow";

export default ({
  title,
  valid = true,
  children,
  footer,
  selected,
  isConnectable,
}) => {
  const cx = classnames.bind(style);

  return (
    <div className={cx({ selected: selected })}>
      <Handle
        type="target"
        position="left"
        className={style.handleTarget}
        isConnectable={isConnectable}
      />
      <div className={cx({ inner: true, needsSetup: !valid })}>
        <div className={style.body}>
          <div className={style.title}>{title}</div>
          {children}
        </div>
        {footer}
      </div>
      <Handle
        type="source"
        position="right"
        className={style.handleSource}
        isConnectable={isConnectable}
      />
    </div>
  );
};
